import { ENDPOINT } from "../../network/ENDPOINT";
import { WEBURL } from "../../constant/comman";

/**
 * Trigger export (either direct stream or async 202 job)
 */
export async function exportUserCardBuyReportAPI(authToken, body) {
  try {
    const url = `${WEBURL}${ENDPOINT.export_user_card_buy_report}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/csv",
        "Content-Type": "application/json",
        authorization: "Berear " + authToken,
      },
      body: JSON.stringify(body),
    });

    const contentType = response.headers.get("content-type") || "";

    // If direct CSV streaming response
    if (contentType.includes("text/csv")) {
      const blob = await response.blob();
      const safeEmail = (body && body.email ? body.email : "user").replace(/[^a-zA-Z0-9_-]/g, "_");
      let fileName = `${safeEmail}_transaction_report.csv`;
      const contentDisposition = response.headers.get("content-disposition");
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) fileName = match[1];
      }

      // Trigger instant browser download
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return {
        status: 200,
        success: true,
        is_stream: true,
        fileName,
      };
    }

    // Otherwise JSON response (e.g. 202 Accepted for async job, or error)
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error in exportUserCardBuyReportAPI:", err);
    throw err;
  }
}

/**
 * Trigger recharge and collection export (either direct stream or async 202 job)
 */
export async function exportUserRechargeCollectionReportAPI(authToken, body) {
  try {
    const url = `${WEBURL}${ENDPOINT.export_user_recharge_collection_report}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/csv",
        "Content-Type": "application/json",
        authorization: "Berear " + authToken,
      },
      body: JSON.stringify(body),
    });

    const contentType = response.headers.get("content-type") || "";

    // If direct CSV streaming response
    if (contentType.includes("text/csv")) {
      const blob = await response.blob();
      const safeEmail = (body && body.email ? body.email : "user").replace(/[^a-zA-Z0-9_-]/g, "_");
      let fileName = `${safeEmail}_recharge_collection_report.csv`;
      const contentDisposition = response.headers.get("content-disposition");
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) fileName = match[1];
      }

      // Trigger instant browser download
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return {
        status: 200,
        success: true,
        is_stream: true,
        fileName,
      };
    }

    // Otherwise JSON response (e.g. 202 Accepted for async job, or error)
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error in exportUserRechargeCollectionReportAPI:", err);
    throw err;
  }
}

/**
 * Fetch recent export jobs
 */
export async function fetchExportJobsAPI(authToken) {
  try {
    const url = `${WEBURL}${ENDPOINT.export_jobs}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        authorization: "Berear " + authToken,
      },
    });
    return await response.json();
  } catch (err) {
    console.error("Error in fetchExportJobsAPI:", err);
    throw err;
  }
}

/**
 * Download a completed export job file
 */
export async function downloadExportJobAPI(authToken, jobId) {
  try {
    const url = `${WEBURL}v1/auth/export-jobs/${jobId}/download`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: "Berear " + authToken,
      },
    });

    if (!response.ok) {
      let errorMsg = "Failed to download export file";
      try {
        const errorData = await response.json();
        if (errorData && errorData.message) errorMsg = errorData.message;
      } catch (e) {}
      throw new Error(errorMsg);
    }

    const blob = await response.blob();
    let fileName = "report_export.csv";
    const contentDisposition = response.headers.get("content-disposition");
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) fileName = match[1];
    }

    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error("Error in downloadExportJobAPI:", err);
    throw err;
  }
}
